module.exports = __webpack_public_path__ + "img/65541.11a98319.jpg";